import React from "react";
import { Box, Link as MuiLink } from "@mui/material";
import { NavLink } from "react-router-dom";
import { NAV_LINKS } from "../../constants/permissions";
import { useUser } from "../../context/UserContext";

const NavigationMobile = ({ onNavClick }) => {
  const { canAccess } = useUser();
  // Hide product sections the user cannot view; non-product links always show.
  const navLinks = NAV_LINKS.filter(
    ({ productKey }) => !productKey || canAccess(productKey)
  );

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        backgroundColor: "#d8d8d8",
        padding: "1rem",
      }}
    >
      <Box
        component="nav"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          margin: "1rem 0 0.5rem 0",
        }}
      >
        {navLinks.map(({ label, path }) => (
          <MuiLink
            key={path}
            component={NavLink}
            to={path}
            underline="none"
            color="inherit"
            onClick={() => onNavClick?.(path)}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              fontWeight: 400,
              fontSize: "1rem",
              width: "16.5rem",
              height: "2.5rem",
              borderBottom: "0.4rem solid #f0f0f0",
              "&.active": {
                borderBottom: "0.4rem solid #E54F9C",
              },
              "&:hover": {
                borderBottom: "0.4rem solid #000000",
              },
            }}
          >
            {label}
          </MuiLink>
        ))}
      </Box>
    </Box>
  );
};

export default NavigationMobile;
